<template>
  <div>
    <div v-if="visivel" style="display: block; padding-top: 0px; z-index:200" class="w3-modal" v-cloak>
      <div class="w3-modal-content" @click.stop>
        <div class="w3-container" style="max-height: calc(100vh - 50px); min-height: 200px; overflow: auto">
          <span @click="visivel = false" class="w3-button w3-display-topright">&times;</span>
          <h4 class="texto-vermelho w3-center">Carregar Crédito no Pedido</h4>
          
          <div style="max-height: calc(95vh - 230px); min-height: 100px; overflow: auto;">

            <div 
              class="w3-col card-item w3-border" 
              v-bind:style="getStyleCredito(index)"
              v-for="(credito, index) in creditos" :key="index">

              <div class="w3-col s8">
                <label class="switch" style="padding: 12px!important;">
                  <input type="checkbox" :disabled="processando" @click="utilizarCredito(index)">
                  <span v-bind:class="getClassUtilizarCredito(index)"><strong style="margin-left: 42%;">Utilizar</strong></span>
                </label>
              </div>
              
              <div class="w3-col s4">

                <div class="w3-right" style="margin-right: 2px;">
                  <legenda v-if="credito.credito_nao_pode_ser_utilizado">
                    <div>Créditos que não poderão ser utilizados</div>
                    <strong slot="referencia" class="max-width">
                      <i class="fas fa-circle w3-text-white"/>
                    </strong>
                  </legenda>
                </div>
                
                <div class="w3-right" style="margin-right: 2px;">
                  <legenda v-if="credito.bloqueado == 'S'">
                    <div>Créditos bloqueados </div>
                    <strong slot="referencia" class="max-width">
                      <i class="fas fa-circle w3-text-red"/>
                    </strong>
                  </legenda>
                </div>
                
                <div class="w3-right" style="margin-right: 2px;">
                  <legenda v-if="credito.emitiu_nota_dev == 'N'">
                    <div>Créditos que não tiveram nota de devolução emitida </div>
                    <strong slot="referencia" class="max-width">
                      <i class="fas fa-circle w3-text-orange"/>
                    </strong>
                  </legenda>
                </div>
                
                <div class="w3-right" style="margin-right: 2px;">
                  <legenda v-if="credito.bol_dup_devolucao_total_aberto == 'S'">
                    <div>Créditos em aberto provenientes de devolução total de vendas no boleto ou duplicata </div>
                    <strong slot="referencia" class="max-width">
                      <i class="fas fa-circle w3-text-purple"/>
                    </strong>
                  </legenda>
                </div>
                
                <div class="w3-right" style="margin-right: 2px;">
                  <legenda v-if="credito.credito_proveniente_devolucao == 'S'">
                    <div>Créditos que ainda não foram recebidos</div>
                    <strong slot="referencia" class="max-width">
                      <i class="fas fa-circle w3-text-green"/>
                    </strong>
                  </legenda>
                </div>
                
                <div class="w3-right" style="margin-right: 2px;">
                  <legenda v-if="credito.recebimento_na_entrega_nao_recebido == 'S'">
                    <div>Créditos prov. de devolução de vendas que são receb. na entrega, mas que ainda não foram recebidos</div>
                    <strong slot="referencia" class="max-width">
                      <i class="fas fa-circle w3-text-blue"/>
                    </strong>
                  </legenda>
                </div>  
              </div>
              
              <div @click="alternarMostrarDetalhes(index)">
                <div class="w3-col s12 m12 l12">
                  <span>Saldo devedor:</span>&nbsp;
                  <strong class="w3-text-green">R$ {{credito.saldo_devedor}}</strong>
                </div>

                <div class="w3-col s12 m12 l12">
                  <span>Índice da condição:</span>&nbsp;
                  <strong class="w3-text-indigo">{{credito.indice_condicao_pagamento}}</strong>
                </div>

                <div class="w3-col s12 m12 l12">
                  <span>Vencimento:</span>&nbsp;
                  <strong>{{credito.data_vencimento}}</strong>
                </div>
                
                <div class="w3-col s12 m12 l12">
                  <span>Cliente:</span>&nbsp;
                  <strong>{{credito.nome_cliente}}</strong>
                </div>

                <div class="w3-col s12 w3-center" v-show="!credito.mostrar_detalhes">
                  <i style="color: #7a7a7a;" class="fas fa-ellipsis-h"></i>  
                </div> 
              </div>
              
              <div v-if="credito.mostrar_detalhes" @click="alternarMostrarDetalhes(index)">
                <div class="w3-col s12 m12 l6">
                  <span>Documento:</span>
                  <strong>{{credito.documento}}</strong>
                </div>

                <div class="w3-col s12 m12 l6">
                  <span>Valor:</span>
                  <strong>R$ {{credito.valor_documento}}</strong>
                </div>

                <div class="w3-col s12 m12 l12">
                  <span>Já adiantado:</span>&nbsp;
                  <strong>{{credito.valor_adiantado}}</strong>
                </div>
                
                <div class="w3-col s12 m12 l12" v-if="credito.orcamento_id">
                  <span>Pedido:</span>&nbsp;
                  <strong>{{credito.orcamento_id}}</strong>
                </div>
                
                <div class="w3-col s12 m12 l12">
                  <span>Emissão:</span>&nbsp;
                  <strong>{{credito.data_emissao}}</strong>
                </div>
                
                <div class="w3-col s12 m12 l12">
                  <span>Financeiro:</span>&nbsp;
                  <strong>{{credito.financeiro_id}}</strong>
                </div>
                
                <div class="w3-col s12 m12 l12" v-if="credito.emitiu_nota_dev == 'N'">
                  <span>Emitiu nota de devolução:</span>&nbsp;
                  <strong>{{credito.emitiu_nota_dev == 'N' ? 'Não' : 'Sim'}}</strong>
                </div>
                
                <div class="w3-col s12 m12 l12" v-if="credito.adiantamento_acumulativo == 'S'">
                  <span>Acum.:</span>&nbsp;
                  <strong>{{credito.adiantamento_acumulativo == 'S' ? 'Sim' : 'Não'}}</strong>
                </div>
              </div>
            </div>
          </div>

          <div class="w3-col s12 m12 l12" style="margin-top: 5px; margin-bottom: 15px;">
            <span>Total selecionado:</span>&nbsp;
            <strong>R$ {{formatarValor(valor_total_creditos_utilizados, 2)}}</strong>
          </div>
          
          <center>
            <button class="w3-btn w3-theme" @click="confirmar()">
              <i class="fas fa-check-circle"/> Ok
            </button>
          </center>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import legenda from '@/components/Legendas'
  import formatarValorMixin from '@/mixins/formatarValorMixin'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  import ROrcamentoBuscarCreditosCliente from '@/components/Rest/ROrcamento/ROrcamentoBuscarCreditosCliente.js'

  export default {
    name: 'ModalCarregarCredito',
    
    components:{
      legenda
    },

    props: {
      orcamentoId: {
        required: true,
        type: Number,
        default: 0
      },
    },

    mixins:[formatarValorMixin],

    data () {
      return {
        visivel: false,
        processando: false,
        creditos:[],
        valor_total_creditos_utilizados: 0,
      }
    },
     
    methods: {
      getClassUtilizarCredito(index){
        
        if (this.creditos[index].utilizar_credito){
          return "slider round";
        } else {
          return "slider-credito round";
        }

        this.$forceUpdate();
      },

      alternarMostrarDetalhes(index){
        this.creditos[index].mostrar_detalhes = !this.creditos[index].mostrar_detalhes;
        this.$forceUpdate();
      },

      getStyleCredito(index){
        let retorno = "padding:0px; margin-button:5px; cursor: pointer; width: 95%; margin-left: 5px;";

        if (index == 0){
          retorno += "margin-top: 10px;";
        }

        if (this.creditos[index].utilizar_credito){
          retorno += "background-color: #f4f5eb;";
        } 

        return retorno;
      },

      async validarCreditosUtilizar(index){
        try {
          let parametros = {
            orcamento_id: this.orcamentoId,
            orcamento_devolucao_id: this.creditos[index].orcamento_devolucao_id,
            financeiro_id: this.creditos[index].financeiro_id,
            bloqueado: this.creditos[index].bloqueado,
            emitiu_nota_dev: this.creditos[index].emitiu_nota_dev,
            bol_dup_devolucao_total_aberto: this.creditos[index].bol_dup_devolucao_total_aberto,
            status_recebimento: this.creditos[index].status_recebimento,
            recebimento_na_entrega_nao_recebido: this.creditos[index].recebimento_na_entrega_nao_recebido
          };

          this.processando = true;
          let retorno = await ROrcamentoBuscarCreditosCliente.validarCreditosUtilizar(this.axios, parametros);
          this.processando = false;

          if (retorno.houve_erro){
            throw new Error(retorno.mensagem);
          }

          if (retorno.dados.houve_erro == 'S'){
            swal(retorno.dados.mensagem);
            return false;
          }

          return true;
        } catch (e) {
          this.processando = false;
          Biblioteca.exclamar(e.message);
          return false;
        }
      },
      
      async utilizarCredito(index){
        try {
          let validouCredito = true;

          // Só validar se estiver marcando para utilizar o crédito
          if (!this.creditos[index].utilizar_credito){
            validouCredito = await this.validarCreditosUtilizar(index);
          }

          if (validouCredito){
            this.creditos[index].utilizar_credito = !this.creditos[index].utilizar_credito;
            this.totalizarCreditosUtilizados();
            this.$forceUpdate();
          }
        } catch (e) {
          Biblioteca.exclamar(e.message);
        }
      },

      async abrir(cadastro_id){
        this.creditos = [];
        this.valor_total_creditos_utilizados = 0;

        if(!cadastro_id){
          Biblioteca.exclamar('Nenhum cliente foi informado!');
          return;
        }
        
        await this.buscarCredito(cadastro_id);
      },
      
      async buscarCredito(cadastro_id){
        try {
          let parametros = {
            cadastro_id: cadastro_id
          };

          let retorno = await ROrcamentoBuscarCreditosCliente.buscarCreditosCliente(this.axios, parametros);

          if (retorno.houve_erro){
            throw new Error(retorno.mensagem);
          }

          this.creditos = JSON.parse(JSON.stringify(retorno.dados));
          this.visivel = true;
        } catch (e) {
          Biblioteca.exclamar(e.message);
        }
      },

      totalizarCreditosUtilizados(){
        this.valor_total_creditos_utilizados = 0;

        for (let i = 0; i < this.creditos.length; i++) {
          if (this.creditos[i].utilizar_credito){
            this.valor_total_creditos_utilizados += Biblioteca.valor(this.creditos[i].saldo_devedor);
          }
        }
      },

      fechar(retorno_creditos_utilizados){
        this.$emit('confirmar', retorno_creditos_utilizados);
        this.visivel = false;
      },

      async confirmar(){
        try {
          let creditos_utilizados = [];
          await this.totalizarCreditosUtilizados();

          for (let i = 0; i < this.creditos.length; i++) {
            if (this.creditos[i].utilizar_credito){

              let validouCredito = await this.validarCreditosUtilizar(i);

              if (!validouCredito){
                return;
              }

              creditos_utilizados.push(this.creditos[i]);
            }
          }

          let retorno_cred_utilizados = {
            valor_total_creditos_utilizados: this.valor_total_creditos_utilizados,
          }

          if (retorno_cred_utilizados.valor_total_creditos_utilizados === 0){
            this.fechar(retorno_cred_utilizados);
            return;
          }
  
          retorno_cred_utilizados.creditos_utilizados = creditos_utilizados;
          this.fechar(retorno_cred_utilizados);
        } catch (e) {
          Biblioteca.exclamar(e.message);
        }
      }
    }
  }

</script>

<style scoped>
  .switch{
    width:100px;
    height: 14px;
  }

  .slider.round {
    border-radius: 34px;
    padding-top: 1px;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    font-size: 14px;
    left: 0;
    right: 0;
    bottom: 2px;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 4px;
    bottom: 2px;
    background-color: #f1f1f1;
    -webkit-transition: .4s;
    transition: .4s;
    box-shadow: #636363 1px 1px 0px 0px;
  }

  input:checked+.slider {
    background-color: #4a993a;
    color:white;
  }
  
  input:checked+.slider:before {
    -webkit-transform: translateX(15px);
    -ms-transform: translateX(15px);
    transform: translateX(15px);
  }

  .slider-credito.round {
    border-radius: 34px;
    padding-top: 1px;
  }

  .slider-credito {
    position: absolute;
    cursor: pointer;
    top: 0;
    font-size: 14px;
    left: 0;
    right: 0;
    bottom: 2px;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .slider-credito.round:before {
    border-radius: 50%;
  }

  .slider-credito:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 4px;
    bottom: 2px;
    background-color: #f1f1f1;
    -webkit-transition: .4s;
    transition: .4s;
    box-shadow: #636363 1px 1px 0px 0px;
  }

  input:checked+.slider-credito {
    background-color: #ccc;
    color:black;
  }
  
  input:checked+.slider-credito:before {
    -webkit-transform: translateX(0px);
    -ms-transform: translateX(0px);
    transform: translateX(0px);
  }
  
  .card-item {
    background-color: white;
    border-radius: 10px;
    box-shadow: #7a7a7a 1px 2px 5px 2px;
    margin-bottom: 10px;
    padding: 5px !important;
  }
  
</style>



// WEBPACK FOOTER //
// src/components/Orcamentos/ModalCarregarCredito.vue